import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	label: {
		id: 'software-backlog-panel.common.estimate-field.label',
		defaultMessage: 'Estimate',
		description: 'Estimate title.',
	},
	points: {
		id: 'software-backlog-panel.common.estimate-field.points',
		defaultMessage: '{totalEstimate, plural, one {# point} other {# points}}',
		description: 'Label for story point estimates.',
	},
	percentageCompleted: {
		id: 'software-backlog-panel.common.estimate-field.percentage-completed',
		defaultMessage: '{percentageCompleted, number, percent} of estimated work complete',
		description: "Percentage of an epic's total estimate completed.",
	},
	unestimatedIssues: {
		id: 'software-backlog-panel.common.estimate-field.unestimated-issues',
		defaultMessage: '{notEstimated, plural, one {# issue} other {# issues}} unestimated',
		description: 'Number of unestimated issues in the epic.',
	},
	pointsTooltip: {
		id: 'software-backlog-panel.common.estimate-field.points-tooltip',
		defaultMessage:
			'{doneEstimate} of {totalEstimate, plural, one {# point} other {# points}} completed',
		description:
			'Hover tooltip for current estimate progress in the epic, with story points as the estimation unit.',
	},
	timeEstimateTooltip: {
		id: 'software-backlog-panel.common.estimate-field.time-estimate-tooltip',
		defaultMessage: '{doneEstimate} of {totalEstimate} completed',
		description:
			'Hover tooltip for current estimate progress in the epic, with time estimates as the estimation unit. doneEstimate and totalEstimate are time strings, not numbers.',
	},
	customEstimateTooltip: {
		id: 'software-backlog-panel.common.estimate-field.custom-estimate-tooltip',
		defaultMessage: '{doneEstimate} of {totalEstimate, plural, one {#} other {#}} {name} completed',
		description:
			'Hover tooltip for current estimate progress in the epic, with a custom number field as the estimation unit.',
	},
	unestimatedIssuesIssueTermRefresh: {
		id: 'software-backlog-panel.common.estimate-field.unestimated-issues-issue-term-refresh',
		defaultMessage: '{notEstimated, plural, one {# work item} other {# work items}} unestimated',
		description: 'Number of unestimated issues in the epic.',
	},
});
